var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/theme-selector.tsx";
import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'soapbox/components/ui';
const messages = defineMessages({
  light: {
    "id": "theme_toggle.light",
    "defaultMessage": "Light"
  },
  dark: {
    "id": "theme_toggle.dark",
    "defaultMessage": "Dark"
  },
  system: {
    "id": "theme_toggle.system",
    "defaultMessage": "System"
  }
});
/** Pure theme selector. */
const ThemeSelector = ({
  value,
  onChange
}) => {
  const intl = useIntl();
  const themeIconSrc = useMemo(() => {
    switch (value) {
      case 'system':
        return require('@tabler/icons/device-desktop.svg');
      case 'light':
        return require('@tabler/icons/sun.svg');
      case 'dark':
        return require('@tabler/icons/moon.svg');
      default:
        return null;
    }
  }, [value]);
  const handleChange = e => {
    onChange(e.target.value);
  };
  return /*#__PURE__*/React.createElement("label", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative rounded-md shadow-sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: themeIconSrc,
    className: "h-4 w-4 text-gray-400",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("select", {
    onChange: handleChange,
    defaultValue: value,
    className: "focus:ring-indigo-500 focus:border-indigo-500 dark:bg-slate-800 dark:border-gray-600 block w-full pl-8 pr-12 sm:text-sm border-gray-300 rounded-md",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: "system",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 11
    }
  }, intl.formatMessage(messages.system)), /*#__PURE__*/React.createElement("option", {
    value: "light",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 11
    }
  }, intl.formatMessage(messages.light)), /*#__PURE__*/React.createElement("option", {
    value: "dark",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 11
    }
  }, intl.formatMessage(messages.dark))), /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/chevron-down.svg'),
    className: "h-4 w-4 text-gray-400",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 11
    }
  }))));
};
export default ThemeSelector;